import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { PulseScoreCell } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { Score } from "@/shared/components/pulse/score";
import { BAND_LABEL, bandOf } from "@/shared/components/pulse/score-band";

export function PulseScoresReadCard({
  title,
  cells,
  viewAllHref,
}: {
  title: string;
  cells: PulseScoreCell[];
  viewAllHref?: string;
}) {
  const shown = cells.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title={title}
      note="out of 10"
      viewAllHref={viewAllHref}
      hiddenCount={cells.length - shown.length}
    >
      {shown.map((cell) => {
        const insufficient = cell.insufficientData === true || cell.score === undefined;
        return (
          <li key={cell.dimension} className="flex items-center justify-between gap-3 px-3 py-2">
            <span className="min-w-0 truncate">{cell.label}</span>
            {insufficient ? (
              <span className="shrink-0 text-xs text-text-tertiary">Not enough responses</span>
            ) : (
              <span className="flex shrink-0 items-center gap-1.5">
                <Score value={cell.score} size="sm" hideSuffix />
                {/* The band colour is the only sighted cue, so the word is for everyone else. */}
                <span className="sr-only">{BAND_LABEL[bandOf(cell.score)]}</span>
              </span>
            )}
          </li>
        );
      })}
    </ReadCardFrame>
  );
}
